import { makeStyles, tokens } from '@fluentui/react-components';
export var useFirstRunFooterStyles = makeStyles({
    container: {
        visibility: 'hidden',
        opacity: '0',
    },
    containerActive: {
        visibility: 'visible',
        opacity: '1',
    },
    pagination: {
        textAlign: 'center',
        height: '10px',
        paddingTop: '8px',
        // forcehardwareaccesleration
    },
    paginationIcon: {
        verticalAlign: 'top',
        zoom: '1',
        display: 'inline',
        width: '8px',
        height: '8px',
        marginRight: '10px',
        color: tokens.colorNeutralStroke1,
        ':last-child': {
            marginRight: '0',
        },
    },
    paginationIconActive: {
        color: tokens.colorCompoundBrandForeground1,
    },
});
//# sourceMappingURL=FirstRunFooter.styles.js.map